import React from 'react';
import { Trans } from 'react-i18next';
import List from '../../../../common/components/list';
import { EventWidgetItem } from './events-widget-item';

import type { Event } from '../../../events/types';
import { Link } from 'react-router-dom';

interface Props {
  events: Event[],
  eventsCounts: {
    upcoming: number,
    draft: number,
    past: number,
    canceled: number,
  },
  networkId: string,
}

export const EventsWidget = ({ events, eventsCounts, networkId }: Props) => (
  <div className="balloon">
    <h5 className="balloon__title">
      <span><Trans i18nKey="social:upcoming_events" />
        {events.length > 0 && <small>{eventsCounts.upcoming}</small>}
      </span>
      <div className="pull-right">
        <Link to={`/networks/${networkId}/events`}>
          <Trans i18nKey="social:view_events" />
        </Link>
      </div>
    </h5>
    <List
      // @ts-expect-error
      items={events.slice(0, 3)}
      renderRow={EventWidgetItem}
      placeholder={(
        <Trans i18nKey="social:no_upcoming_events" />
      )}
    />
  </div>
);
